module.exports = __webpack_public_path__ + "img/vipevent_preference_icon@2x.c3502c8f.png";